<template>
  <div>
    <b-modal
      id="base-documents-modal"
      ref="base-documents-modal"
      centered
      title="Download Selected Files"
      :no-close-on-backdrop="true"
      hide-footer
      cancel-variant="outline-secondary"
      @show="resetModal"
    >
      <b-overlay
        id="overlay-background"
        :show="loader"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-card
          no-body
          class="business-card"
        >
          <b-card-body>
            <b-alert
              v-if="alertErrors.length > 0"
              variant="warning"
              show
            >
              <h4 class="alert-heading">
                {{ $t('DEBITA_ERROR') }}
              </h4>
              <div
                v-for="(error, index) in alertErrors"
                :key="index"
                class="alert-body"
              >
                <span>{{ error }}</span>
              </div>
            </b-alert>
            <div
              v-if="baseDocumentsCategories.length > 0"
              class="business-items"
            >
              <div
                class="business-item"
              >
                <div class="d-flex align-items-center justify-content-between">
                  <label class="category-font label-bolder">
                    {{ $t('DEBITA_CATEGORY') }}
                  </label>
                  <label class="category-font label-margin label-bolder">
                    {{ $t('DEBITA_ACTION') }}
                  </label>
                </div>
              </div>
              <div
                v-for="(category, index) in baseDocumentsCategories"
                :key="index"
                class="business-item"
              >
                <div class="d-flex align-items-center justify-content-between">
                  <label class="category-font">
                    {{ category.name }}
                  </label>
                  <b-form-checkbox
                    @change="getCategoryID($event, category.id, category.debt_stage)"
                  >
                    {{ $t('DEBITA_GROUP_TEXT') }}
                  </b-form-checkbox>
                </div>
              </div>
            </div>
            <div
              v-if="baseDocumentTemplates.length > 0"
              class="business-items"
            >
              <div
                class="business-item"
              >
                <div class="d-flex align-items-center justify-content-between">
                  <label class="category-font label-bolder">
                    {{ $t('DEBITA_TEMPLATE') }}
                  </label>
                  <label class="category-font label-margin label-bolder">
                    {{ $t('DEBITA_ACTION') }}
                  </label>
                </div>
              </div>
              <div
                v-for="(template, index) in baseDocumentTemplates"
                :key="index"
                class="business-item"
              >
                <div class="d-flex align-items-center justify-content-between">
                  <label class="category-font">
                    {{ template.name }}
                  </label>
                  <b-form-checkbox
                    @change="getTemplateID($event, template.id)"
                  >
                    {{ $t('DEBITA_GROUP_TEXT') }}
                  </b-form-checkbox>
                </div>
              </div>
            </div>

            <!-- button -->
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              block
              @click="download()"
            >
              {{ $t('DEBITA_DOWNLOAD') }}
            </b-button>
          </b-card-body>
        </b-card>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BOverlay, BFormCheckbox, BButton, BCard, BCardBody, BAlert,
} from 'bootstrap-vue'
import axios from '@axios'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BOverlay,
    BAlert,
    // BFormInput,
    BFormCheckbox,
    BButton,
    BCard,
    BCardBody,
  },
  directives: {
    Ripple,
  },
  props: {
    baseDocumentsCategories: {
      type: Array,
      required: true,
    },
    baseDocumentTemplates: {
      type: Array,
      required: true,
    },
    selectedBaseDocuments: {
      type: Array,
      required: true,
    },
    allBaseDocuments: {
      type: Array,
      required: true,
    },
    checkAll: {
      type: Boolean,
      required: true,
    },
    refreshCheckboxes: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      loader: false,
      checkedCategories: [],
      checkedTemplates: [],
      alertErrors: [],
      defaultGroups: [],
    }
  },
  watch: {
  },
  created() {
  },
  methods: {
    resetModal() {
      this.checkedCategories = []
      this.checkedTemplates = []
      this.defaultGroups = []
      this.alertErrors = []
    },
    getCategoryID(event, id, debtStage) {
      if (event && id === 0) {
        this.defaultGroups.push(debtStage)
      }
      if (!event && id === 0) {
        const defaultCategoryToRemove = this.defaultGroups.indexOf(debtStage)
        this.defaultGroups.splice(defaultCategoryToRemove, 1)
      }
      if (event && id !== 0) {
        this.checkedCategories.push(id)
      }
      if (!event && !id) {
        const categoryToRemove = this.checkedCategories.indexOf(id)
        this.checkedCategories.splice(categoryToRemove, 1)
      }
    },
    getTemplateID(event, id) {
      if (event) {
        this.checkedTemplates.push(id)
      } else {
        const templateToRemove = this.checkedTemplates.indexOf(id)
        this.checkedTemplates.splice(templateToRemove, 1)
      }
    },
    async download() {
      this.alertErrors = []
      this.loader = true
      const caseId = this.$route.params.id
      let ids = this.selectedBaseDocuments
      let categoryIds = []
      let filesData = []
      if (this.selectedBaseDocuments.length === 0) {
        ids = []
        this.allBaseDocuments.forEach(document => {
          ids.push(document.id)
          categoryIds.push(document.category_id)
        })
        categoryIds = new Set(categoryIds)
        filesData = this.allBaseDocuments
      } else {
        this.selectedBaseDocuments.forEach(element => {
          const filteredObj = this.allBaseDocuments.filter(documentelement => element === documentelement.id)
          filesData.push(filteredObj[0])
        })
      }
      const files = []
      filesData.forEach(element => {
        const obj = {
          category_id: element.category_id || null,
          category_name: element.category || null,
          template_id: element.template_id || element.letter_template_id || null,
          template_name: element.template_name || null,
          debt_stage: element.debt_stage || null,
          link: element.file_link || null,
        }
        files.push(obj)
      })
      const obj = {
        debt_case_id: Number(caseId),
        ids,
        default_groups: this.defaultGroups,
        all_checked: this.checkAll,
        category_ids: this.checkedCategories,
        template_ids: this.checkedTemplates,
        files_data: files,
      }
      await axios.post('/generate-pdf-link', obj).then(responseLocal => {
        if (responseLocal.status) {
          const fileUrl = responseLocal.data.data.file_link
          const linkArray = fileUrl.split('/')

          // Create a hidden anchor element
          const link = document.createElement('a')
          link.href = fileUrl

          // Specify the desired filename for the downloaded file
          link.download = linkArray[linkArray.length - 1]

          // Append the anchor to the document body
          document.body.appendChild(link)

          // Programmatically trigger a click event on the anchor
          link.click()

          // Remove the anchor from the document body
          document.body.removeChild(link)
          // this.errorMsg = ''
          this.loader = false
          this.refreshCheckboxes()
          this.$refs['base-documents-modal'].hide()
          this.checkedCategories = []
          this.checkedTemplates = []
          this.defaultGroups = []
        }
      }).catch(err => {
        this.loader = false
        const message = err.response?.data?.message
        if (Array.isArray(message)) {
          this.alertErrors = message
        } else if (message) {
          this.alertErrors = [message]
        } else {
          this.alertErrors = []
        }
      })
    },
  },
}
</script>

<style lang="scss">
.category-font {
  font-size: 14px;
}

.label-margin {
  margin-right: 100px;
}

.label-bolder {
  font-weight: bold;
}
</style>
